const quoteLabels = [
    {
        title: 'Información General',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREEMPRESA]',
                description: 'company_name',
                visible: true
            },
            { label: '[CLIENTE]', description: 'customer_name', visible: true },
            {
                label: '[FECHASOLICITUD]',
                description: 'request_date',
                visible: true
            },
            { label: '[AGENCIA]', description: 'agency_name', visible: true },
            {
                label: '[CIUDADDESTINO]',
                description: 'destination_city',
                visible: true
            }
        ]
    },
    {
        title: 'Dimensiones',
        type: 'columns',
        fields: [
            { label: '[PIEZAS]', description: 'pieces', visible: true },
            { label: '[PESO]', description: 'total_weight', visible: true },
            { label: '[LARGO]', description: 'length', visible: true },
            { label: '[ANCHO]', description: 'width', visible: true },
            { label: '[ALTO]', description: 'height', visible: true },
            { label: '[VOLUMEN]', description: 'total_volume', visible: true }
        ]
    },
    {
        title: 'Costos',
        type: 'columns',
        fields: [
            { label: '[TARIFA]', description: 'rate', visible: true },
            { label: '[VALOR]', description: 'value', visible: true },
            { label: '[FLETE]', description: 'freight', visible: true },
            { label: '[SEGURO]', description: 'insurance', visible: true },
            { label: '[IMPUESTOS]', description: 'taxes', visible: true },
            { label: '[ADICIONAL]', description: 'additional', visible: true },
            { label: '[ARANCELES]', description: 'duties', visible: true },
            { label: '[TOTAL]', description: 'total', visible: true }
        ]
    }
];

export default quoteLabels;
